import styled, { css } from 'styled-components';

import { TagAppearance } from './Tag.js';

import { Color, Gradient } from '../../../shared/constants/Colors.js';
import {
  FontSize,
  FontType,
  FontWeight,
} from '../../../shared/constants/Fonts.js';
import { Transition } from '../../../shared/constants/Styles.js';

const ThemeTag = css`
  transition: ${Transition.ALL_EASE};
  cursor: pointer;
  min-height: ${({ appearance }) =>
    appearance === TagAppearance.BIG ? '45px' : '30px'};
  min-width: 100%;
  min-width: fit-content;
  padding: 5px 12px;
  border-radius: ${({ appearance }) =>
    appearance === TagAppearance.BIG ? '22.5px' : '15px'};
  border: 2px solid transparent;
  background-clip: padding-box;
  outline: 0;
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.BLACK};
  letter-spacing: 0;
  line-height: 16px;
  box-sizing: border-box;

  &:focus-visible {
    border: 2px solid ${Color.CLOUD_BURST};
  }
`;

export const StyledLink = styled.a`
  ${ThemeTag};
  text-decoration: none;
  background-color: ${Color.WHISPER};
  color: ${Color.DOLPHIN};

  &:hover {
    color: ${Color.WHITE};
    background-image: ${Gradient.FADE_BLUE};
    background-color: none;
  }
`;

export const StyledTag = styled.button`
  ${ThemeTag};
  background-image: ${({ isSelected }) =>
    isSelected ? Gradient.FADE_BLUE : 'none'};
  background-color: ${({ isSelected }) =>
    isSelected ? 'none' : Color.WHISPER};
  color: ${({ isSelected }) => (isSelected ? Color.WHITE : Color.DOLPHIN)};

  &:hover {
    background-image: ${({ isSelected }) =>
      isSelected ? Gradient.FADE_BLUE : 'none'};
    background-color: ${({ isSelected }) =>
      isSelected ? 'none' : Color.MYSTIC};
  }
`;
